import { useEffect, useState } from 'react';
import { LanguageProvider } from './context/LanguageContext.js';
import Home from './pages/Home.js';
import UpdateAvailableModal from './components/UpdateAvailableModal.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';
import './App.css';

function App() {
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => setWaitingWorker(registration.waiting),
    });

    let hasReloaded = false;
    const onControllerChange = () => {
      if (hasReloaded) return;
      hasReloaded = true;
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener('controllerchange', onControllerChange);
    return () => navigator.serviceWorker?.removeEventListener('controllerchange', onControllerChange);
  }, []);

  const reloadApp = () => waitingWorker?.postMessage({ type: 'SKIP_WAITING' });

  return (
    <LanguageProvider>
      <div className="App">
        <Home />
        {waitingWorker && (
          <UpdateAvailableModal onReload={reloadApp} onClose={() => setWaitingWorker(null)} />
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
